import React from "react";
import {Typography} from "../../../../designSystem/components/Typography";
import {Paragraph} from "../../../../designSystem/components/Paragraph";
import {GoBackNavigationIconButton} from "../../../../widgets/GoBackNavigationIconButton";

export const UserTermsFeature = () => (
  <div className="p-8 flex flex-col gap-y-6">
    {/* Go back button */}
    <div className="self-start">
      <GoBackNavigationIconButton/>
    </div>

    {/* Title */}
    <div className="flex flex-col gap-y-4">
      <Typography variant="title" align="center">
        屏東遠距醫療諮詢
      </Typography>
      <Typography variant="title" align="center">
        應用程式使用條款
      </Typography>
    </div>

    {/* Content */}
    <div>
      <Paragraph
        text="歡迎使用【屏東遠距醫療諮詢】應用程式服務(以下簡稱本服務)，下列使用條款(以下簡稱本條款)，系統服務範圍涵蓋健康益友(包括下列機構及日後增設之機構)之間的法律協議，同時規範您使用本服務之行為。"/>
      <Paragraph
        text="本服務由特定第三方應用程式供應商資源所構成，平台保留隨時變更本條款及本服務內容的權利，您可隨時點往詳閱最新版條款。凡點核取方塊即表示同意本款及本服務，若您在版本變更後仍繼續使用本服務，視為同意本條款及服務內容等之變更。如您不同意任何更新版本，您必須立即刪除【屏東遠距醫療諮詢】官方帳號或登出帳戶。"/>
      <Paragraph
        text="1. 本服務的特定活動，必須由您先行提供個人基本資料。如您在使用本應用程式時，有需要提供您的相關資訊時,您應提供最即時、完整且正確的資訊。您在使用本應用程式時所提供的相關資訊，醫師都視為是您個人或您依法或經合法授權(在您為第三方進行掛號時)所提供之資訊，且您應為您所提供之資訊之正確性及完整自行負責，醫師不就因您所提供之資訊或因您所提供之資訊不完整或不正確所生之結果負責。"/>
      <Paragraph
        text="2. 您在使用本應用程式時，會利用您註冊之LINE帳號。請妥善使用並保管您的帳號，以免遭到第三人的不當使用。使用您的帳號所進行之一切行為均視為您本人之行為，由您自行負責。"/>
      <Paragraph text="3. 服務內容"/>
      <Paragraph tab={1}
                 text="(1) 本服務是用於協助您管理您（包括您依法有權或經授權為其行使權利義務之親友）的服務諮詢、相關活動訊息提醒等。"/>
      <Paragraph tab={1}
                 text="(2) 您可以透過本服務為您依法有權或經其授權之家人進行諮詢，所提供諮詢資訊、內容、訊息等僅做為參考使用，不具有醫療或診療目的，亦不能取代任何專業醫療諮詢或診斷或適用於任何醫療緊急狀況、診療或疾病及症狀治療。如有任何個人健康或醫療相關問題及疑問，請諮詢醫師。若是醫療緊急情況，應馬上撥打119 或當地緊急救護電話送醫急救。"/>
      <Paragraph text="4. 被蒐集的個人資料與告知事項"/>
      <Paragraph tab={1} text="(1) 醫師於本服務有效營運期間得於營運所在地區利用您個人資料。"/>
      <Paragraph tab={1}
                 text="(2) 除法令要求或合於法令規範或經您書面同意外，於任何醫師所提供之服務內，我們不會向任何第三方揭露任何可以識別您個人之資訊。惟本局就本應用程式及本服務之管理，委託資訊廠商蒐集、處理與利用您個人識別之資訊者(包括使用第三方雲端服務儲存和處理您的個人資料)，不在此限。您在此同意，醫師為人類醫療之提升，將對所保有的特種個資及一般個資予以去識別化後已無從直接或間接識別特定個人者，提供學術研究或加值合作。"/>
      <Paragraph tab={1}
                 text="(3) 本服務依法僅在醫師內部或其委任處理營業相關第三人間進行您個人資料的交互運用及揭露、交付予第三人時，訂有保密協定，以維護您個人資料的機密性與限制其用途。"/>
      <Paragraph tab={1}
                 text="(4) 您得對醫師請求查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用及請求刪除使用者個人資料。若欲行使前述權利，可與醫師聯繫。請注意若您拒絕提供使用本服務所需必要之個人資料，則無法使用本服務。"/>
      <Paragraph tab={1}
                 text="(5) 為提供本服務，會收集您的部分個人資料，例如足以辨識您個人的身體描述、症狀描述、健康紀錄(包含您的姓名、電話、LINE帳號、出生年月日、身高、體重、醫療報告、治療與診斷紀錄、檢驗結果等)資料。您所提供之個人資料，僅作為協助您個人管理您的諮詢資訊使用，為促進及維護您的健康，醫師將依您的需求，隨時以APP、手機簡訊或社群網路等通訊媒體提供相關就診服務、預防保健等相關訊息。"/>
      <Paragraph tab={1}
                 text="(6) 本服務使用者透過 Line 與本服務所進行之對話，將儲存於 Line 的雲端服務伺服器，該儲存於 Line雲端服務伺服器之對話內容，將直至使用者刪除其 Line 帳號時才會刪除。"/>
      <Paragraph tab={1} text="(7) 個人資料保護法特定目的及個人資料之類別："/>
      <Paragraph tab={1} text={`
              代號 特定目的項目 代號 識別類\n
              ○○一 人身保險業務（依保險法令規定辦理之人身保險相關業務)\n
              Ｃ○○一 辨識個人者:姓名、職稱、通訊及戶籍地址、指紋、電子郵遞地址、電子簽章等\n
              ○一二 公共衛生或傳染病防治 Ｃ○○三 身分證統一編號、殘障手冊號碼、證照號碼、護照號碼等\n
              ○二五 犯罪預防、刑事偵查、執行、矯正、保護處分、犯罪被害人保護或更生保護事務\n
              Ｃ○一一 個人描述: 年齡、性別、出生年月日、國籍等\n
              ○三一 全民健康保險、勞工保險、農民保險、國民年金保險或其他社會保險\n
              Ｃ○一二 身體描述:身高、體重、血型等\n
              ○四二 兵役、替代役行政\n
              Ｃ○一三 習慣:抽煙、喝酒等\n
              ○五五 法院執行業務\n
              Ｃ○二一 家庭情形:結婚有無、配偶或同居人之姓名、前配偶或同居人之姓名、子女之人數等。\n
              ○六四 保健醫療服務\n
              Ｃ○二二 婚姻之歷史:前次婚姻或同居、離婚或分居。\n
              一〇八 救護車服務\n
              Ｃ○三四 旅行及其他遷徙細:旅行細節、外國護照、居留證明文件及工作證照等\n
              一三七 資通安全與管理\n
              Ｃ○三八 職業\n
              一五六 衛生行政\n
              Ｃ○四○ 意外或其他事故及有關情形\n
              一五九 學術研究\n
              Ｃ○四一 法院、檢察署或其他審判機關或其他程序。\n
              一六八 護照、簽證及文件證明處理\n
              Ｃ一一一 健康紀錄\n
            `}/>
      <Paragraph text="5. 授權"/>
      <Paragraph tab={1}
                 text="(1) 在本條款有效期間內，且在您完全遵守本條款所有條款與條件之前提下，醫師同意以目的碼形式授予您，個人的、不可轉讓且非專屬的權利，以供您在個人擁有的行動裝置上基於非商業用途安裝及使用本服務，並得以檢視所收到之通知。"/>
      <Paragraph tab={1} text={`
              醫師所授予您的權利，係以您遵守下列限制為條件。您不得：\n
              • 規避本應用程式中的任何技術限制，或使用本應用程式或結合任何用於規避技術限制之裝置、程式或服務，企圖規避或破壞用於控制或存取內容或權限之技術措施。\n
              • 對本應用程式進行還原工程、解編、破解、反向組譯，或以其他方式試圖存取。\n
              • 本應用程式之原始碼，惟相關法律明文許可或禁止此種限制者，不在此限。\n
              • 散佈、移轉、揭露或以其他方式將本應用程式或內容提供予任何第三人。\n
              • 修改本應用程式或內容之全部或一部，或以此創作任何衍生著作。\n
              • 移除任何本應用程式或內容或其副本上的所有權通知或標示。\n
              • 發表、出租、出借或再授權本應用程式或內容。\n
              • 將本應用程式或內容用於營利目的。\n\n
              使用本應用程式或內容侵害醫師、醫師關係企業或任何第三人之權利，或以任何違反相關法律之方式使用本服務或內容。
            `}/>
      <Paragraph text="6. 服務變更或停止"/>
      <Paragraph tab={1}
                 text="(1) 您所提供之個人資料如有填寫不實、原所登錄資料已不符合真實而未更新、所提供之個人資料違反或破壞醫師服務宗旨或有任何誤導之虞者，醫師有權拒絕提供您使用網站服務之一部份或全部。"/>
      <Paragraph tab={1}
                 text="(2) 醫師將盡最大努力維護本服務的正常運作以及資料安全，基於網際網路之特性，您瞭解並同意使用本服務時，應自行採取防護措施，如因醫師、協力廠商或相關電信業者網路系統軟硬體設備之故障、失靈或人為操作疏失，致網站服務全部或一部中斷、暫時無法使用、遲延，造成資料傳輸或儲存之漏誤，或遭第三人侵入系統篡改偽造資料等，醫師不負任何賠償責任。"/>
      <Paragraph tab={1}
                 text="(3) 如您有違反本條款、相關法令或有其他不當使用本服務之情形，醫師得不經催告逕行加以限制或終止您使用服務之權利，您不得因此要求補償或賠償，一旦您違反本條款之任何條款和條件，本條款將自動終止。"/>
      <Paragraph text="7. 通知"/>
      <Paragraph tab={1}
                 text="醫師將會不定時發送自動通知。例如，當您於本服務之帳戶有任何異動時，我們也許會寄發通知給您。某些的通知是允許您手動設定、取消或重新啟動的。醫師也可能隨時增加新的通知或自行決定停止提供某些通知。"/>
      <Paragraph text="8. 其他"/>
      <Paragraph tab={1}
                 text="本條款之解釋與適用，以及與本條款有關或使用者與醫師間因智慧醫療服務而產生之爭議或糾紛，應依照中華民國法律予以處理，並以臺灣臺北市地方法院為第一審管轄法院。如您對本條款或本服務有任何意見或疑義，請與我們聯繫"/>
    </div>
  </div>
)